import React from "react";
import { useTranslation } from "react-i18next";

export default function Helpcus() {
  const { t } = useTranslation("help");

  return (
    <div className="endpoint-container">
      <a href="#create-endpoint-script" className="endpoint-title">
        {t("Helpcus.title", "Create Endpoint using script")}
      </a>

      <pre className="code-block">
        <code>{`import requests

url = f"https://demo.whitehax.com/api/external/endpoint-config/create/"


ENDPOINT_NAME = ""
ENDPOINT_TYPE = ""  # ${t("Helpcus.endpointTypeComment", "must be one of: api_endpoint, llm_model_endpoint, mcp_endpoint")}
ENDPOINT_PARAMS = {
    "url": "",
    "selection": "scripts"
}
ENDPOINT_DESCRIPTION = ""


payload = {
    "endpoint_name": ENDPOINT_NAME,
    "endpoint_type": ENDPOINT_TYPE,
    "endpoint_params": ENDPOINT_PARAMS,
    "endpoint_description": ENDPOINT_DESCRIPTION,
}
files = [
    (
        "inputScript",
        (
            "input_script.py",
            open("input_script.py", "rb"),
            "application/octet-stream",
        ),
    ),
    (
        "outputScript",
        (
            "output_script.py",
            open("output_script.py", "rb"),
            "application/octet-stream",
        ),
    ),
]
headers = {"Authorization": EXTERNAL_API_KEY}

response = requests.request("POST", url, headers=headers, data=payload,
files=files)

print(response.text)`}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 0;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 26px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 4;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .endpoint-container {
            padding: 0;
          }

          .endpoint-title {
            font-size: 15px;
            margin-bottom: 20px;
          }

          .code-block {
            font-size: 13px;
            line-height: 1.45;
            overflow-x: auto;
          }
        }
      `}</style>
    </div>
  );
}